import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type CustomTagListOption from 'lumen/models/custom-tag-list-option';

export default class CustomTagDefinition extends Model {
  [Type] = 'custom-tag-definition' as const;

  @hasMany('custom-tag-list-option', { async: false, inverse: 'definition' })
  declare options: HasMany<CustomTagListOption>;

  @attr('string') declare name: string;
  @attr('boolean') declare readOnly: boolean;
  @attr('string') declare tagType: 'list' | 'text' | 'user';
}
